<template>
  <div>
    <div v-if="isDialogOpen" class="background" @click="onClose"></div>
    <div v-if="isDialogOpen" class="dialog">
      <ul class="list">
        <li
          v-for="item in taizaiTimeList"
          :key="item.text"
          @click="onClick(item)"
          class="list-item"
        >
          <span>{{ item.display }}滞在する</span>
          <span class="time"
            >{{ startTime }} - {{ getEndtime(item.alltimeDuration) }}</span
          >
          <span class="duration"
            ><img src="@/assets/clock.svg" class="clock" alt="" />{{
              formatDateFromSeconds(item.duration)
            }}</span
          >
          <img class="chev" src="@/assets/chevron.svg" />
        </li>
        <div class="button close" @click="onClose">閉じる</div>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";
import { IC_LIST_BEFORE, IC_LIST_AFTER } from "../../const.js";

const HACHIOUJI = new window.google.maps.LatLng(
  "35.64076604201434",
  "139.24668990833808",
);

const OHTSUKI = new window.google.maps.LatLng(
  "35.611605848542126",
  "138.93244394549106",
);
export default {
  name: "start-time-select-dialog",
  components: {},
  props: {
    current: { type: String, required: true },
  },
  data() {
    return {
      isDialogOpen: false,
      taizaiTimeList: [
        {
          display: "30分",
          sec: 30 * 60,
        },
        {
          display: "1時間",
          sec: 60 * 60,
        },
        {
          display: "2時間",
          sec: 120 * 60,
        },
        {
          display: "3時間",
          sec: 180 * 60,
        },
      ],
    };
  },
  computed: {
    ...mapState(["selectedSpotData", "search", "DepLatLng", "DesLatLng"]),
    selectedSpot() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotData.jyutai;
      }
    },
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
      return "test";
    },
    currentSearchDep() {
      if (this.currentSearch.departure === "現在地") {
        return this.currentDepLatLng;
      }
      return this.currentSearch.departure;
    },
    currentSearchDes() {
      if (this.currentSearch.destination === "現在地") {
        return this.currentDesLatLng;
      }
      return this.currentSearch.destination;
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
      return "test";
    },
    startRawDate() {
      return this.currentSearch
        ? new Date(this.currentSearch.departureTime)
        : new Date();
    },
    startTime() {
      const date = this.startRawDate;

      const hour = this.zeroPaddingAndStr(date.getHours());
      const minute = this.zeroPaddingAndStr(date.getMinutes());
      return `${hour}:${minute}`;
    },
  },
  methods: {
    ...mapMutations([
      "loadingStartMini",
      "loadingEndMini",
      "setDropDestionaton",
      "setSearchState",
    ]),
    zeroPaddingAndStr(num) {
      if (num < 10) {
        return "0" + String(num);
      }
      return String(num);
    },
    formatDate(date) {
      const hour = this.zeroPaddingAndStr(date.getHours());
      const minute = this.zeroPaddingAndStr(date.getMinutes());
      return `${hour}:${minute}`;
    },
    getEndtime(value) {
      const date = this.currentSearch
        ? new Date(this.currentSearch.departureTime)
        : new Date();
      date.setSeconds(date.getSeconds() + value);
      const hour = this.zeroPaddingAndStr(date.getHours());
      const minute = this.zeroPaddingAndStr(date.getMinutes());
      return `${hour}:${minute}`;
    },
    onClick(item) {
      const latlng = new window.google.maps.LatLng(
        this.selectedSpot.lat,
        this.selectedSpot.lon,
      );
      this.setDropDestionaton({
        latlng: latlng,
        name: this.selectedSpot.name,
        stayTime: item.sec,
      });
      this.setSearchState("result");
    },
    onClose() {
      this.$emit("click-close");
    },
    formatDateFromSeconds(value) {
      // 秒からX時間Y分に変換
      const hour = Math.floor(value / 3600);
      const minute = Math.round((value % 3600) / 60);
      return `${hour}時間${minute}分`;
    },
  },
  async mounted() {
    this.loadingStartMini();
    const selectedLatLng = new window.google.maps.LatLng(
      this.selectedSpot.lat,
      this.selectedSpot.lon,
    );
    var directionsService = new window.google.maps.DirectionsService();
    await Promise.all(
      this.taizaiTimeList.map(async (item, index) => {
        if (
          this.currentSearch &&
          this.currentSearch.departure !== this.currentSearch.destination
        ) {
          let time = this.currentSearch
            ? new Date(this.currentSearch.departureTime)
            : new Date();

          if (time < new Date()) {
            time = new Date();
          }
          // ルート検索から来ており、出発地と目的地が異なる場合
          const response = await directionsService.route({
            origin: this.currentDepLatLng,
            destination: selectedLatLng,
            travelMode: window.google.maps.TravelMode.DRIVING,
            drivingOptions: {
              departureTime: time,
              trafficModel: "bestguess",
            },
          });

          time.setSeconds(
            time.getSeconds() +
              response.routes[0].legs[0].duration.value +
              item.sec,
          );

          const result1 = await directionsService.route({
            origin: selectedLatLng,
            destination: this.currentDesLatLng,
            travelMode: window.google.maps.TravelMode.DRIVING,
            drivingOptions: {
              departureTime: time,
              trafficModel: "bestguess",
            },
          });

          let resultDuration =
            response.routes[0].legs[0].duration.value +
            result1.routes[0].legs[0].duration.value;

          let alltimeDuration = resultDuration + item.sec;

          // 大月→八王子を通るのは山梨方面→東京方面
          // 立ち寄り箇所は目的地付近（八王子以降）にあるとする
          // ので、出発地→立ち寄り箇所にて大月→八王子を通るかどうか？でNEXCO APIを利用するかを判定する
          // そのうえで、出発→大月→【NEXCO API】→八王子→立ち寄り箇所→【滞在時間加算】→目的地で計算しなおす
          const text = JSON.stringify(response);
          if (
            Number(this.currentDesLatLng.lng()) > Number(HACHIOUJI.lng()) &&
            text.indexOf("中央自動車道") !== 1 &&
            IC_LIST_BEFORE.some((item) => text.indexOf(item) !== -1) &&
            IC_LIST_AFTER.some((item) => text.indexOf(item) !== -1)
          ) {
            let time = this.currentSearch
              ? new Date(this.currentSearch.departureTime)
              : new Date();

            if (time < new Date()) {
              time = new Date();
            }
            let durationSum = 0;

            const result = await directionsService.route({
              origin: this.currentDepLatLng,
              destination: OHTSUKI,
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: time,
                trafficModel: "bestguess",
              },
            });

            time.setSeconds(
              time.getSeconds() + result.routes[0].legs[0].duration.value,
            );

            durationSum = result.routes[0].legs[0].duration.value;

            // 現在とtargetの間の分数の差を求める
            const diff = Math.round(
              (time.getTime() - new Date().getTime()) / 1000 / 60,
            );
            let num = Math.round(diff / 5);
            if (num > 65) {
              num = 60;
            }

            const result2 = await axios.get(
              "https://predict.traveltime.jp/t6hegs/?t=rct&acc=0",
            );

            const tyuoudo_min = result2.data.data[0].result[num];
            time.setMinutes(time.getMinutes() + tyuoudo_min);
            durationSum = durationSum + tyuoudo_min * 60;

            const result3 = await directionsService.route({
              origin: HACHIOUJI,
              destination: selectedLatLng,
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: time,
                trafficModel: "bestguess",
              },
            });
            time.setSeconds(
              time.getSeconds() +
                result3.routes[0].legs[0].duration.value +
                item.sec,
            );

            durationSum =
              durationSum + result3.routes[0].legs[0].duration.value;

            const result4 = await directionsService.route({
              origin: selectedLatLng,
              destination: this.currentDesLatLng,
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: target,
                trafficModel: "bestguess",
              },
            });

            durationSum =
              durationSum + result4.routes[0].legs[0].duration.value;

            resultDuration = durationSum;
            alltimeDuration = durationSum + item.sec;
          }

          this.taizaiTimeList[index] = {
            ...item,
            alltimeDuration: alltimeDuration,
            duration: resultDuration,
          };
        }
      }),
    );
    this.loadingEndMini();

    this.isDialogOpen = true;
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: calc(100% - 2rem * 2);
  overflow-y: scroll;
  padding: 1rem;
  border-radius: 12px;

  .list {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 0.8rem;
    .list-item {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 0.1fr;
      padding: 1rem 0.5rem;
      border-bottom: 1px solid #e7e7e7;
      align-items: center;
      .time {
        vertical-align: center;
        font-size: 0.8rem;
        color: #aaa;
      }
      .duration {
        display: flex;
        align-items: center;
      }
      .clock {
        height: 1rem;
        margin-right: 0.25rem;
      }
      .chev {
        height: 0.5rem;
        transform: rotate(-90deg);
      }
    }
  }
}

.button {
  color: #5cd5d6;
  margin-top: 2rem;
  padding: 0 0.75rem;
  text-align: center;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelect/DropTimeSelectDialog.vue